export default function removeAllMediaElements(container) {
  const videoNodes = container.querySelectorAll('video');
  const audioNodes = container.querySelectorAll('audio');
  Array.from(videoNodes).forEach(node => node.remove());
  Array.from(audioNodes).forEach(node => node.remove());
}
